
function executeForLargeScreens() {
  if (window.innerWidth > 991) {
    
    const slides = document.querySelectorAll('.slider-slide');
    const totalSlides = slides.length;
    let currentIndex = 0;
    
    function updateSlides() {
      slides.forEach((slide, i) => {
        slide.className = 'slider-slide';
    
        const position = (i + currentIndex + totalSlides) % totalSlides;
        slide.classList.add(`slider-slide-${position + 1}`);
      });
    }
    
    function startSlider() {
      setInterval(() => {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlides();
      }, 7000);
    }
    
    updateSlides();
    startSlider();
  }
}

executeForLargeScreens();
